/* This file is generated by scripts/i18n/generate-taxonomy-wiring.mjs. */
import sourceTaxonomy from '../../assets/i18n/taxonomy/en.generated.json' with { type: 'json' };
import translation0 from '../../i18n/taxonomy/es.generated.json' with { type: 'json' };

export const GENERATED_TAXONOMY_LOCALES = [
    'en',
    'es',
] as const;

type GeneratedTaxonomy = {
    overlayLocale: string;
    source: unknown;
    translations: unknown;
};

const generatedTaxonomies: Readonly<Record<string, GeneratedTaxonomy>> = {
    'en': { overlayLocale: 'en', source: sourceTaxonomy, translations: undefined },
    'es': { overlayLocale: 'es', source: sourceTaxonomy, translations: translation0 },
};

export function getGeneratedTaxonomy(locale: string): GeneratedTaxonomy | undefined {
    return generatedTaxonomies[locale];
}
